import * as React from 'react';
import { Field } from 'redux-form';

import Checkbox from 'af-fields/Checkbox';

interface OwnProps {
	isExcluded: boolean;
}

type Props = OwnProps;

const ExcludeFromNotifyAll: React.FC<Props> = ({ isExcluded }) => {

	const [excludeFromNotifyAll, setExcludeFromNotifyAll] = React.useState(isExcluded);

	const handleChange = React.useCallback(() => {
		setExcludeFromNotifyAll(!excludeFromNotifyAll);
	}, [excludeFromNotifyAll]);

	return (
		<div className="user-upsert__invite">
			<Field
				component={Checkbox}
				inline={true}
				isDisabled={false}
				isStandalone={true}
				label="Exclude from Notify All messages"
				name="excludeFromNotifyAll"
				onChange={handleChange}
				tooltipMessage="When sending notifications through Communication, having this option selected will prevent them from being sent to this user."
				type="text"
			/>
		</div>
	);
};

export default React.memo(ExcludeFromNotifyAll);
